import API from "@config/shared/api-paths";
import { ROLE_NAMES } from "@config/shared/roles";
import { notifySessionChange } from "@utils/shared/session-storage-sync";

const ROLE_ID_MAP = {
  admin: "1",
  manager: "2",
  editor: "3",
  author: "4",
  contributor: "5",
  member: "6",
  accreditor: "7",
  noaccess: "8",
};

/**
 * Migrates legacy user role format to the { role, roleId } shape.
 * Mutates and returns the same user object.
 */
export const migrateUserRole = (user) => {
  if (user.roleId && /^\d+$/.test(user.roleId)) return user;

  if (/^\d+$/.test(user.role)) {
    user.roleId = user.role;
    user.role = ROLE_NAMES[user.role] || "member";
  } else {
    user.roleId = ROLE_ID_MAP[user.role] || "6";
  }
  return user;
};

/**
 * Returns true when the JWT access token is expired.
 * Throws if the token cannot be decoded.
 */
export const isTokenExpired = (accessToken) => {
  const decoded = JSON.parse(atob(accessToken.split(".")[1]));
  const now = Math.floor(Date.now() / 1000);
  return decoded.exp <= now;
};

/**
 * Attempts to obtain a new token pair using the refresh token.
 * Returns `{ access, refresh }` on success, or `null` on failure.
 */
export const tryRefreshToken = async (refreshToken) => {
  try {
    const response = await fetch(`${API.BASE}${API.AUTH.REFRESH}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${refreshToken}` },
    });
    if (!response.ok) return null;

    const data = await response.json();
    sessionStorage.setItem("accessToken", data.access);
    sessionStorage.setItem("refreshToken", data.refresh);
    console.debug("[Auth] Token refreshed successfully");
    // Rotated refresh token — propagate the new pair to sibling tabs so none of
    // them keeps refreshing with a stale token and triggers a cross-tab logout.
    notifySessionChange();
    return data;
  } catch {
    return null;
  }
};
